import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const MarketoForm = ({ assetId, onSuccessfulSubmit }) => {
  if (!assetId) return null;

  const [submitted, setSubmitted] = useState(null);

  const initializeMarketo = () => {
    const loadScript = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src =
        'https://register.fastcompany.com/js/forms2/js/forms2.min.js';
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
    if (typeof window.MktoForms2 === 'undefined') {
      return loadScript;
    }
    return Promise.resolve();
  };

  const loadReCaptcha = () => {
    const loadScript = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src =
        'https://www.google.com/recaptcha/api.js?render=6Ld-cloiAAAAADnaV1gWOVIezI4ZTBObJcn0ZM1R';
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
    if (typeof window.grecaptcha === 'undefined') {
      return loadScript;
    }
    return Promise.resolve();
  };

  useEffect(() => {
    // Don't re-initialize if already loaded
    window.loadedNewsletters = window.loadedNewsletters || [];
    if (window.loadedNewsletters.includes(parseInt(assetId, 10))) {
      return;
    }
    window.loadedNewsletters.push(assetId);

    initializeMarketo()
      .then(loadReCaptcha)
      .then(() => {
        // Marketo instance config
        const mktoFormConfig = {
          podId: '//register.fastcompany.com',
          munchkinId: '610-LEE-872',
          formIds: [assetId]
        };

        // Below code supplied via Marketo forum support
        // see: https://nation.marketo.com/t5/product-discussions/two-forms-one-page/td-p/135459
        function mktoFormChain(config) {
          const arrayify = getSelection.call.bind([].slice);
          const MKTOFORM_ID_ATTRNAME = 'data-formId';

          window.MktoForms2.whenRendered(form => {
            const formEl = form.getFormElem()[0];
            const submitBtn = formEl.nextElementSibling.querySelector('button');
            submitBtn.classList.add('g-recaptcha');
            submitBtn.setAttribute(
              'data-sitekey',
              '6Ld-cloiAAAAADnaV1gWOVIezI4ZTBObJcn0ZM1R'
            );
            submitBtn.setAttribute('data-callback', 'onSubmit');
            submitBtn.setAttribute('data-action', 'submit');
            submitBtn.onclick = () => {
              // When the button is clicked, get the form object and submit it
              form.submit();
            };
            // Success Handler
            form.onSuccess(() => {
              setSubmitted(true);
              if (onSuccessfulSubmit) onSuccessfulSubmit();
              submitBtn.parentElement.innerHTML =
                '<span class="success__message">Thank you! Look out for your first email.</span>';
              return false;
            });
            const rando = `_${new Date().getTime() + Math.random()}`;

            arrayify(formEl.querySelectorAll('label[for]')).forEach(labelEl => {
              const forEl = formEl.querySelector(`[id="${labelEl.htmlFor}"]`);
              if (forEl) {
                // eslint-disable-next-line
                labelEl.htmlFor = forEl.id = forEl.id + rando;
              }
            });
          });

          arrayify(config.formIds).forEach(formId => {
            const loadForm = window.MktoForms2.loadForm.bind(
              window.MktoForms2,
              config.podId,
              config.munchkinId,
              formId
            );
            const formEls = arrayify(
              document.querySelectorAll(`[${MKTOFORM_ID_ATTRNAME}="${formId}"]`)
            );

            (function loadFormCallback(currentFormEls) {
              const formEl = currentFormEls.shift();
              formEl.id = `mktoForm_${formId}`;

              loadForm(() => {
                formEl.id = '';
                if (currentFormEls.length) {
                  loadFormCallback(currentFormEls);
                }
              });
            })(formEls);
          });
        }

        mktoFormChain(mktoFormConfig);
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.log('Error initializing Marketo: ', err);
      });
  }, []);

  return (
    <form
      key={`mktoForm_${assetId}`}
      id={`mktoForm_${assetId}`}
      data-formid={assetId}
      className={`marketo__form mktoForm marketo__form--${
        submitted ? 'submitted' : 'default'
      } custom__button`}
    />
  );
};

MarketoForm.defaultProps = {
  onSuccessfulSubmit: () => {}
};

MarketoForm.propTypes = {
  assetId: PropTypes.number.isRequired,
  onSuccessfulSubmit: PropTypes.func
};

export default React.memo(MarketoForm);
